<template>
	<div class="chat_wrapper type_login">
		<!-- 로그인 start -->
		<div class="login_wrapper">
			<div class="login_img">
				<span class="bg_clip">사학연금</span>
			</div>
			<div class="login_tit">
				사학연금
			</div>

			<!-- 로그인 폼 start -->
			<div class="login_form">
				<form @submit.prevent="login">
					<fieldset>
						<legend>로그인</legend>
						<ul class="login_input">
							<li>
								<input
									ref="mbrId"
									v-model="userData.mbrId"
									type="text"
									class="chat_form_gray"
									placeholder="아이디"
								/>
							</li>
							<li>
								<input
									ref="pw"
									v-model="userData.pw"
									type="password"
									class="chat_form_gray"
									placeholder="비밀번호"
								/>
							</li>
						</ul>
						<div class="login_save_wrap">
							<input
								id="auto_login"
								type="checkbox"
								v-model="autoLogin"
							/><label for="auto_login">자동 로그인</label>
						</div>

						<ul class="bot_btnset horizontal align_center half">
							<li>
								<button
									class="btn medium primary_c_bd"
									type="button"
									@click="onClickSignup"
								>
									회원가입
								</button>
							</li>
							<li>
								<button class="btn medium primary_c" type="submit">
									로그인
								</button>
							</li>
						</ul>
					</fieldset>
				</form>
			</div>
			<!--// 로그인 폼 end -->
		</div>
		<!--// 로그인 end -->

		<!-- 로그인 푸터 start -->
		<div class="login_foot">
			<ul>
				<li>
					<img
						src="../../assets/img_chatbot/layout/foot_logo01.png"
						alt="HCT : Human-Centered Convergence Technology"
					/>1
				</li>
				<li>
					<img
						src="../../assets/img_chatbot/layout/foot_logo02.png"
						alt="보건복지부"
					/>2
				</li>
				<li>
					<img
						src="../../assets/img_chatbot/layout/foot_logo03.png"
						alt="KHIDI : 한국보건산업진흥원"
					/>3
				</li>
			</ul>
			<div class="copyright">
				Copyright@HTC. All rights reserved.
			</div>
		</div>
		<!--// 로그인 푸터 end -->
	</div>
</template>

<script>
// eslint-disable-next-line no-undef
require('es6-promise').polyfill();
import UtilsCrypto from '../../api/crypto';
import storage from '../../api/storage';
import config from '../../config/config.json';
import Signup from './Signup';

export default {
	name: 'Login',
	components: {},
	data: function() {
		return {
			userData: {
				mbrId: '',
				pw: '',
			},
			autoLogin: false,
		};
	},
	mounted() {
		this.$refs.mbrId.focus();
	},
	methods: {
		login() {
			if (!this.userData.mbrId) {
				alert('아이디 항목은 필수 항목입니다.');
				this.$refs.mbrId.focus();
				return;
			}
			if (!this.userData.pw) {
				alert('비밀번호 항목은 필수 항목입니다.');
				this.$refs.pw.focus();
				return;
			}
			this.userData.pw = UtilsCrypto.cryptoAesEncrypt(this.userData.pw);
			// 로그인 시도!!!!!!!
			this.$axios
				.post(config.MBR_REST_API_PATH + '/mem/login', null, {
					params: {
						mbrId: this.userData.mbrId,
						pw: this.userData.pw,
					},
				})
				.then(response => {
					if (response.data) {
						if (response.data.approval === 'true') {
							// 로그인 성공
							if (this.autoLogin) {
								storage.local.setUserData(response.data);
							}
							storage.session.setUserData(response.data);
							window.location.href = config.PATH;
						} else {
							alert('관리자의 승인 후 로그인이 가능합니다.');
						}
					} else {
						// 로그인 실패
						alert('아이디 및 비밀번호를 다시 확인해주세요.');
					}
				})
				.catch(error => {
					console.log(error);
				})
				.finally(() => {
					this.userData.mbrId = '';
					this.userData.pw = '';
					this.$refs.mbrId.focus();
				});
		},
		onClickSignup() {
			this.$modal.show(
				Signup,
				{},
				{
					clickToClose: true,
					height: 'auto',
				},
			);
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/member/Login.vue